import SEO from '../components/SEO';
import Marquee from '../components/Marquee';
import Hero from '../components/home/Hero';
import Journey from '../components/home/Journey';
import WhoWeHelp from '../components/home/WhoWeHelp';
import Services from '../components/home/Services';
import CareerExplorer from '../components/home/CareerExplorer';
import RoadmapFeature from '../components/home/RoadmapFeature';
import Consultation from '../components/home/Consultation';
import Plans from '../components/home/Plans';
import WhyUs from '../components/home/WhyUs';
import ResourcesHub from '../components/home/ResourcesHub';
import FreeResources from '../components/home/FreeResources';
import Testimonials from '../components/home/Testimonials';
import FAQ from '../components/home/FAQ';
import FinalCTA from '../components/home/FinalCTA';

const Home = () => (
  <main data-testid="home-page">
    <SEO
      title="CareerWithRaaj | Career Guidance, Career Planning & Skill Development"
      description="Build your career with clarity. CareerWithRaaj offers career guidance for students, stream selection after 10th, course & college selection, career roadmaps, and skill development in Tamil Nadu & Chennai."
    />
    <Hero />
    <Marquee items={['Career Guidance', 'Skill Development', 'Career Planning', 'Discover. Decide. Develop.']} />
    <Journey />
    <WhoWeHelp />
    <Services />
    <CareerExplorer />
    <RoadmapFeature />
    <Consultation />
    <Plans />
    <WhyUs />
    <ResourcesHub />
    <FreeResources />
    <Testimonials />
    <FAQ />
    <FinalCTA />
  </main>
);

export default Home;
